import { apiFetch } from './client';

export function normalizeSuggestion(raw) {
  const item = raw?.suggestion || raw || {};
  return {
    id: item.suggestion_id || item.id || (item.pk ? item.pk.replace('SUGGEST#', '') : ''),
    pk: item.pk || '',
    sk: item.sk || '',
    customerSub: item.customer_sub || item.customer_id || '',
    name: item.name || '',
    notes: item.notes || '',
    barcode: item.barcode || '',
    status: item.status || 'NEW',
    opsNote: item.ops_note || '',
    createdAt: item.created_at || null,
    updatedAt: item.updated_at || null,
    updatedBy: item.updated_by || '',
  };
}

export async function listProductSuggestions(token, { status } = {}) {
  const query = status && status !== 'ALL' ? `?status=${encodeURIComponent(status)}` : '';
  const data = await apiFetch(`/store/product-suggestions${query}`, { token });
  const list = data?.suggestions || (Array.isArray(data) ? rawList(data) : []);
  return list.map(normalizeSuggestion);
}

function rawList(data) {
  if (Array.isArray(data)) return data;
  return [];
}

export async function updateProductSuggestion(id, { status, opsNote }, token) {
  const body = {};
  if (status) body.status = status;
  if (opsNote !== undefined) body.ops_note = opsNote.trim();

  const raw = await apiFetch(`/store/product-suggestions/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    token,
    body,
  });

  return normalizeSuggestion(raw);
}
